<div [class]="'cdp-job-chip' + ' job-chip-' + size" [class.is-active]="isActive" [title]="tooltip">
    <span class="icon-left icon-toolbox"></span>
    <span class="mode-code" [innerHTML]="displayStr | highlight: search"></span>
</div>
